import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AssinaturaCancelado = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 820, mx: 'auto', mt: 4, px: 2 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Pagamento não concluído
          </Typography>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Você cancelou o processo de assinatura. Se quiser, tente novamente.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/assinar', { replace: true })}>
            Voltar
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AssinaturaCancelado;
